import { Endpoint } from '@philips-emr/hpms-provider-commons';
import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';
import { HistoryService, HttpService, OpenIDConnectService } from '@philips-emr/tws-core/lib/services';

import { OidcAliases as Aliases, FragmentNames } from '../codegen';

@Controller({ fragment: FragmentNames.OIDC })
class OidcController {

  @OnMount(Aliases.PANEL_OIDC)
  onMountOidc(): void {
    const state = OpenIDConnectService.getState();
    if (state) {
      void HttpService.post(Endpoint.POST.SSO, { state: state.id }, {}).then((resp) => {
        const callback = resp.body as string;
        HistoryService.redirect(callback);
      });
    }
  }
}

export {
  OidcController,
};
